export default __webpack_public_path__ + "static/media/page_notice.e0d14bea.png";